import React from 'react';
import { WeekBar } from '../goalsTargetsTypes';
import styles from './WeeklyPerformance.module.css';

interface WeeklyPerformanceProps {
  weeks: WeekBar[];
}

export const WeeklyPerformance: React.FC<WeeklyPerformanceProps> = ({ weeks }) => {
  const max = Math.max(...weeks.map((w) => Math.max(w.current, w.target)));
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Weekly Performance</h3>
      <div className={styles.list}>
        {weeks.map((w) => {
          const pct = (w.current / max) * 100;
          return (
            <div key={w.id} className={styles.row}>
              <div className={styles.label}>
                <p className={styles.weekLabel}>{w.label}</p>
                <p className={styles.weekDesc}>{w.description}</p>
              </div>
              <div className={styles.barWrap}>
                <span
                  className={`${styles.bar} ${styles[`bar_${w.color}`]}`}
                  style={{ width: `${pct}%` }}
                />
              </div>
              <div className={styles.amount}>
                <p className={styles.value}>{w.amount}</p>
                <p className={styles.target}>{w.ofTarget}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
